<style>
    .r-cup-bar {
        padding: .2rem 0 .2rem;
    }
    /** cupBox **/
    .cupBox {
        border: 1px solid rgba(0, 0, 0, 0.1);
        border-radius: 0.1rem;
        -webkit-box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);
        -moz-box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);
        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);
    }

    .cupBox.skin-full {
        border-width: 1px 0;
        border-radius: 0px;
    }

    .cupBox.skin-full .cupBox__head,
    .cupBox.skin-full .cupBox__body {
        border-radius: 0px;
    }

    .cupBox__head {
        height: 0.5rem;
        line-height: 0.5rem;
        border-top-left-radius: 0.1rem;
        border-top-right-radius: 0.1rem;
        background: #4A3B0A;
    }

    .cupBox__body {
        position: relative;
        top: 0;
        left: 0;
        background: #301F01 url("https://staticcdn-prd.pydp888.com/award/kline/img/1.0/cup_box_bg.png?v=1.0.7") 50% 50% no-repeat;
        background-size: 100% auto;
        border: 1px solid #5B411B;
        border-width: 0 1px 1px;
        border-bottom-left-radius: 0.1rem;
        border-bottom-right-radius: 0.1rem;
    }

    .cupBox--current .cupBox__body {
        padding-bottom: 0.99rem;
    }

    .cupBox__title {
        font-weight: normal;
        padding-left: 0.15rem;
        font-size: 0.24rem;
    }

    .cupTitle__name {
        font-size: .36rem;
    }

    .cupBox__rank {
        position: absolute;
        top: -0.5rem;
        right: 0.15rem;
        width: 1.8rem;
        height: 2.16rem;
        text-align: center;
        background: url("https://staticcdn-prd.pydp888.com/award/kline/img/1.0/page_2.1_bg_rank.png?v=1.0.7") 50% 0 no-repeat;
        background-size: cover;
    }

    .cupBox__rank .tit {
        padding: 0.2rem 0 0px;
        line-height: 1;
        font-size: 0.24rem;
    }

    .cupBox__rank .no {
        line-height: 1.6rem;
        font-size: 0.44rem;
    }

    .cupBox__rank .txt {
        line-height: 1;
        font-size: 0.24rem;
    }

    .cupBox__rank .need-login {
        font-size: 0.24rem;
        line-height: 2;
    }

    .cupBox__rank .need-login:first-child {
        padding-top: 0.4rem;
    }

    .cupBox__rank.size-sm {
        position: absolute;
        top: 0px;
        right: 0.15rem;
        width: 1.77rem;
        height: 1.46rem;
        text-align: center;
        background: url("https://staticcdn-prd.pydp888.com/award/kline/img/2.1/bg_rank.png?v=1.0.7") 50% 0 no-repeat;
        background-size: cover;
    }

/** cupItem **/
.cupItem {
  position: relative;
  top: 0;
  left: 0;
  color: #fdb141;
}
.cupItem__inner {
  min-height: 1.66rem;
}
.cupItem:before,
.cupItem:after {
  content: " ";
  display: table;
}
.cupItem:after {
  clear: both;
}
.m-kresult-cup .cupItem {
  background: none;
}
.cupItem__inner {
  padding-bottom:  0.2rem;
}
.cupItem__inner:before,
.cupItem__inner:after {
  content: " ";
  display: table;
}
.cupItem__inner:after {
  clear: both;
}
.cupItem__logo {
  position: absolute;
  left:  0.15rem;
  top:  0.2rem;
  width:  1.48rem;
  height:  1.4rem;
  text-align: center;
  z-index: 8;
}
.cupItem__logo:after {
  width:  1.48rem;
  height:  1.4rem;
  display: block;
  content: " ";
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  background: url("https://staticcdn-prd.pydp888.com/award/kline/img/1.0/cup_logo_cover.png?v=1.0.7") 50% 0 no-repeat;
  background-size: cover;
}
.cupItem__logo .img {
  margin: 0 auto;
  text-align: center;
  padding-top:  0px;
  width:  1.46rem;
  z-index: 1;
}
.cupItem__logo .img img {
  width:  1.46rem;
  height:  1.38rem;
  border-radius:  0.1rem;
}
.cupItem__info {
  padding-top:  0.2rem;
  padding-left:  1.78rem;
  z-index: 8;
}
.cupItem__info dd {
  line-height:  0.4rem;
  font-size:  0.24rem;
}
.cupItem__link {
  display: block;
  position: absolute;
  left:  0.15rem;
  top:  0.2rem;
  width:  2.98rem;
  height:  1.4rem;
  z-index: 101;
}
.cupItem__link span {
  visibility: hidden;
}
.cupItem__btns {
  box-sizing: border-box;
  margin-top:  0.4rem;
  padding:  0 0.1rem;
}
.cupItem__btns ul {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-justify-content: space-around;
  -ms-flex-pack: distribute;
  justify-content: space-around;
}
.cupBox__rank {
  position: absolute;
  top:  -0.5rem;
  right:  0.15rem;
  width:  1.8rem;
  height:  2.16rem;
  text-align: center;
  background: url("https://staticcdn-prd.pydp888.com/award/kline/img/1.0/page_2.1_bg_rank.png?v=1.0.7") 50% 0 no-repeat;
  background-size: cover;
}
.cupBox__rank a,
.cupBox__rank a:visited {
    color: #FFB231;
}
.cupBox__rank .tit {
  padding:  0.2rem 0 0px;
  line-height: 1;
  font-size:  0.24rem;
}
.cupBox__rank .no {
  line-height:  0.9rem;
  font-size:  0.44rem;
}
.cupBox__rank .txt {
  line-height: 1;
  font-size:  0.24rem;
}
.cupBox__rank .need-login {
  font-size:  0.24rem;
  line-height:  2;
}
.cupBox__rank .need-login:first-child {
  padding-top:  0.4rem;
}
.cupBox__rank.size-sm {
  position: absolute;
  top:  0px;
  right:  0.15rem;
  width:  1.77rem;
  height:  1.46rem;
  text-align: center;
  background: url("https://staticcdn-prd.pydp888.com/award/kline/img/2.1/bg_rank.png?v=1.0.7") 50% 0 no-repeat;
  background-size: cover;
}
.cupBox__rank.size-sm .tit {
  padding:  0.1rem 0 0px;
  line-height:  0.26rem;
  font-size:  0.2rem;
}
.cupBox__rank.size-sm .no {
  line-height:  0.8rem;
  font-size:  0.42rem;
}
.cupBox__rank.size-sm .txt {
  line-height:  0.26rem;
  font-size:  0.2rem;
}
</style>
<template>
    <div class="r-cup-bar">
        <txt-loading v-if="!cup" />
        <div v-else class="cupBox cupBox--simple skin-default">
            <div class="cupBox__head">
                <h3 class="cupBox__title">{{matchName}}</h3>
            </div>
            <div class="cupBox__body">
                <div class="cupItem cupItem--actual">
                    <div class="cupItem__inner">
                        <div class="cupItem__logo">
                            <div class="img"><img :src="cup.cupLogo"></div>
                        </div>
                        <div class="cupItem__info">
                            <dl><dt class="cupTitle">
                                    <div class="cupTitle__name">{{cup.cupName}}</div>
                                </dt>

                                <dd v-if="cupPlayer && cupPlayer.finishTime" class="avgScore">完成时间：<span  class="cl_danger">{{cupPlayer.finishTime}}</span></dd>
                                <dd v-else class="avgScore">完成时间：<span class="cl_danger">未完成</span></dd>

                                <dd v-if="nowTime > finalRes" class="avgScore">平均得分：<span v-if="cupPlayer && cupPlayer.finishTime" class="cl_danger">{{cupPlayer.gameScore}}</span><span v-else class="cl_danger">-</span></dd>
                                <dd v-else class="avgScore">平均得分：<span class="cl_danger">{{finalRes, 'M月D日hh:mm公布'|time2text}}</span></dd>
                                <!-- <dd>{{JSON.stringify(cupPlayer, null, 2)}}</dd> -->
                            </dl>
                        </div>
                        <!-- <div class="cup-explain-summary">本期已发表讲解：<span class="person-num">1人</span>，
                            共<span class="total">2条</span><a href="javascirpt:;" class="btn-detail" x-click="wz.goUrl"
                                data-url="/award/klinev2/explain/list?cupId=158&amp;cupType=1"></a></div>
                        <a class="cupItem__link" href="javascript:;" x-click="dk.playerCup.games" data-cup-id="158"
                            data-uid="100056"><span>点击查看</span></a> -->
                    </div>
                </div>
                <div class="cupBox__rank size-sm"><a href="javascript:;" x-click="dk.rankCup" data-cup-id="158">
                        <dl><dt class="tit">当前排名</dt>
                            <dd v-if="isFinishFinal" class="no">{{finalRank}}</dd>
                            <dd v-else class="no">暂无</dd>
                        </dl>
                    </a></div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        mapGetters
    } from 'vuex'
    export default {
        name: 'r-cup-bar',
        props: ['cupId'],
        computed: {
            ...mapGetters(['matchName', 'isFinishFinal', 'finalRank', 'nowTime', 'finalRes']),
            ...mapGetters('reality', ['cupPlayer', 'getCup']),
            cup() {
                return this.getCup(this.cupId)
            }
        }
    }
</script>
